import type { FC } from "react";

import { styled } from "styled-components";

import { SearchInput, DotsLoader } from "@similarweb/ui-components";

interface ISearchContainerProps {
    onChange: (value: string) => void;
    value: string;
    loading: boolean;
    placeholder: string;
}

const Impersonate = styled.div`
    position: relative;
    z-index: 100;
    display: block;
    width: 95%;
    max-width: 100%;
    height: 40px;
    box-sizing: border-box;
`;

export const SearchContainer: FC<ISearchContainerProps> = ({ value, onChange, loading, placeholder }) => (
    <Impersonate>
        <SearchInput
            defaultValue={value}
            loadingComponent={<DotsLoader />}
            debounce={300}
            onChange={onChange}
            isLoading={loading}
            className="impersonate-searchInput"
            placeholder={placeholder}
            autoFocus
        />
    </Impersonate>
);
